import React, { forwardRef } from 'react'
import {
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Seller_Tax_System_Enum } from '@gql'
import { ControllerRenderProps } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

type SellerTaxSystemSelectProps = {
  field: ControllerRenderProps<any>
  className?: string
}
export const SellerTaxSystemSelect = forwardRef<
  HTMLInputElement,
  SellerTaxSystemSelectProps
>(({ field, className }, ref) => {
  const { t } = useTranslation()
  return (
    <FormItem className={className}>
      <FormLabel>{t('SellerTaxSystemSelect.label')}</FormLabel>
      <Select onValueChange={field.onChange} value={field.value}>
        <FormControl>
          <SelectTrigger className="tw-w-full">
            <SelectValue
              ref={ref}
              placeholder={t('SellerTaxSystemSelect.placeholder')}
            />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          {Object.values(Seller_Tax_System_Enum).map((system) => (
            <SelectItem value={system} key={system}>
              {t(`SellerTaxSystemSelect.${system}`)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <FormMessage />
    </FormItem>
  )
})

SellerTaxSystemSelect.displayName = 'SellerTaxSystemSelect'
